/* Angular Modules */
import {Component} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent  {
	constructor(
    public router: Router) {
  }

	isImageSound(): boolean {
    return true;
	}
	isMusicStyling(): boolean {
    return false;
	}
}
